import AddIcon from '@material-ui/icons/Add';
import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Mentor } from '../../api/mentors';
import { useMentorsContext } from '../../contexts/mentors-context';
import { UserContext } from '../../contexts/user-context';
import { getRoutePath, Pages } from '../../router/constants';
import TableActions from '../common/table-actions';

function MentorsRowActions({
  mentor,
  variant,
}: {
  mentor: Mentor;
  variant?: 'table' | 'list';
}) {
  const history = useHistory();
  const location = useLocation();
  const { hasAccessToAction } = useContext(UserContext);
  const { setProfileUpdateTargetMentorId, setAssignTargetMentor } =
    useMentorsContext();

  const prevPath = `${location.pathname}${location.search}`;

  return (
    <TableActions
      variant={variant}
      actions={[
        {
          key: 'row-action-note',
          onClick: () =>
            history.push({
              pathname: getRoutePath(Pages.MENTOR_NOTES, {
                mentorId: mentor.id,
              }),
              state: { prevPath },
            }),
          icon: <AddIcon fontSize='small' color='inherit' />,
          label: 'Note',
          hidden: !hasAccessToAction('mentor.notes.view'),
        },
        {
          key: 'row-action-request-profile-update',
          onClick: () => setProfileUpdateTargetMentorId(mentor.id),
          label: 'Request Profile Update',
          hidden: !hasAccessToAction('mentor.details.update'),
        },
        {
          key: 'row-action-assign-mentor',
          onClick: () => setAssignTargetMentor(mentor),
          label: 'Assign',
          hidden: !hasAccessToAction('mentor.details.update'),
        },
      ]}
    />
  );
}

export default MentorsRowActions;
